import React, { FC } from 'react'
import { ImageSliderListBase } from './ImageSliderListBase'
import { useMutation, useQuery } from '@apollo/client'
import { GetImageSlider, UpdateImageSlider } from '../graphql/website-settings.graphql'
import { translate } from '../../../core'
import { message } from 'antd'

export const ImageSliderListDefault: FC = () => {
  const [messageApi, contextHolder] = message.useMessage()
  const {data, loading} = useQuery(GetImageSlider, {
    notifyOnNetworkStatusChange: true,
  })
  const [update] = useMutation(UpdateImageSlider, {
    refetchQueries: [GetImageSlider],
    onCompleted: () => messageApi.success(translate('image_slider', 'save_success_message')),
    onError: error => messageApi.error(error.message),
  })

  return (
    <React.Fragment>
      <p className='f-medium font-weight-600 mx-2'>Recommended image dimensions: 1895 × 1080 pixels (3:2 aspect ratio)</p>
      <ImageSliderListBase
        loading={loading}
        onUpdate={async input => {
          await update({
            variables: {
              input,
            }
          })
        }}
        images={data?.adminWebsiteSettings.imageSlider ?? []}
      />
      {contextHolder}
    </React.Fragment>
  )
}